"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var PlayerForm_1 = __importDefault(require("../../components/PlayerForm"));
PlayerForm_1.default.getInstance();
